var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", [
    _c("div", { staticClass: "resportList" }, [
      _c("div", [
        _c("div", { staticClass: "headerTitle-top" }, [
          _c(
            "div",
            {
              staticClass: "picker-alls",
              on: {
                click: function($event) {
                  _vm.showDeptAreaPop = !_vm.showDeptAreaPop
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.queryParams.deptAreaName || "请选择区域") +
                  "\n          "
              ),
              _c("div", { staticClass: "triangle_border_down" })
            ]
          ),
          _vm._v(" \n        "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showDeptAreaPop,
                  expression: "showDeptAreaPop"
                }
              ]
            },
            [
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showDeptAreaPop,
                    callback: function($$v) {
                      _vm.showDeptAreaPop = $$v
                    },
                    expression: "showDeptAreaPop"
                  }
                },
                [
                  _c("van-picker", {
                    attrs: {
                      "show-toolbar": "",
                      columns: _vm.deptAreaList,
                      "value-key": "name"
                    },
                    on: {
                      confirm: _vm.deptAreaChange,
                      cancel: function($event) {
                        _vm.showDeptAreaPop = !_vm.showDeptAreaPop
                      }
                    },
                    model: {
                      value: _vm.queryParams.deptArea,
                      callback: function($$v) {
                        _vm.$set(_vm.queryParams, "deptArea", $$v)
                      },
                      expression: "queryParams.deptArea"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "picker-alls",
              on: {
                click: function($event) {
                  _vm.showDeptPop = !_vm.showDeptPop
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.queryParams.deptName || "请选择门店") +
                  "\n          "
              ),
              _c("div", { staticClass: "triangle_border_down" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showDeptPop,
                  expression: "showDeptPop"
                }
              ]
            },
            [
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showDeptPop,
                    callback: function($$v) {
                      _vm.showDeptPop = $$v
                    },
                    expression: "showDeptPop"
                  }
                },
                [
                  _c("van-picker", {
                    attrs: {
                      "show-toolbar": "",
                      columns: _vm.deptList,
                      "value-key": "deptName"
                    },
                    on: {
                      confirm: _vm.deptChange,
                      cancel: function($event) {
                        _vm.showDeptPop = !_vm.showDeptPop
                      }
                    },
                    model: {
                      value: _vm.queryParams.deptId,
                      callback: function($$v) {
                        _vm.$set(_vm.queryParams, "deptId", $$v)
                      },
                      expression: "queryParams.deptId"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "headerTitle-top" }, [
          _c(
            "div",
            { staticClass: "picker-alls" },
            [
              _c(
                "div",
                {
                  staticClass: "flex item1",
                  on: {
                    click: function($event) {
                      _vm.showDateTime1 = !_vm.showDateTime1
                    }
                  }
                },
                [
                  _vm.queryParams.startDate
                    ? _c("p", { staticClass: "item1 date-time black" }, [
                        _vm._v(_vm._s(_vm.queryParams.startDate))
                      ])
                    : _c("p", { staticClass: "item1 date-time" }, [
                        _vm._v(
                          _vm._s(_vm.queryParams.startDate || "请选择开始日期")
                        )
                      ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "triangle_border_down",
                    attrs: { slot: "right-icon" },
                    slot: "right-icon"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom" },
                  model: {
                    value: _vm.showDateTime1,
                    callback: function($$v) {
                      _vm.showDateTime1 = $$v
                    },
                    expression: "showDateTime1"
                  }
                },
                [
                  _c("van-datetime-picker", {
                    attrs: { type: "date" },
                    on: {
                      confirm: _vm.getFirstDate,
                      cancel: function($event) {
                        _vm.showDateTime1 = !_vm.showDateTime1
                      }
                    },
                    model: {
                      value: _vm.defaultStartTime,
                      callback: function($$v) {
                        _vm.defaultStartTime = $$v
                      },
                      expression: "defaultStartTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v("-\n        "),
          _c(
            "div",
            { staticClass: "picker-alls" },
            [
              _c(
                "div",
                {
                  staticClass: "flex item1",
                  on: {
                    click: function($event) {
                      _vm.showDateTime2 = !_vm.showDateTime2
                    }
                  }
                },
                [
                  _vm.queryParams.endDate
                    ? _c("p", { staticClass: "item1 date-time black" }, [
                        _vm._v(_vm._s(_vm.queryParams.endDate))
                      ])
                    : _c("p", { staticClass: "item1 date-time" }, [
                        _vm._v(
                          _vm._s(_vm.queryParams.endDate || "请选择结束日期")
                        )
                      ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "triangle_border_down",
                    attrs: { slot: "right-icon" },
                    slot: "right-icon"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom" },
                  model: {
                    value: _vm.showDateTime2,
                    callback: function($$v) {
                      _vm.showDateTime2 = $$v
                    },
                    expression: "showDateTime2"
                  }
                },
                [
                  _c("van-datetime-picker", {
                    attrs: { type: "date" },
                    on: {
                      confirm: _vm.getEndDate,
                      cancel: function($event) {
                        _vm.showDateTime2 = !_vm.showDateTime2
                      }
                    },
                    model: {
                      value: _vm.defaultEndTime,
                      callback: function($$v) {
                        _vm.defaultEndTime = $$v
                      },
                      expression: "defaultEndTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "div-query-area" },
          [
            _c(
              "van-row",
              {
                attrs: { gutter: "6", type: "flex", justify: "space-between" }
              },
              [
                _c(
                  "van-col",
                  { attrs: { span: "12" } },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: { plain: "", type: "danger", size: "small" },
                        on: { click: _vm.event4Clear }
                      },
                      [_vm._v("清空")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "van-col",
                  { attrs: { span: "12" } },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: { click: _vm.queryReportData }
                      },
                      [_vm._v("查询")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "headerTitle-top picker-report-choose" }, [
          _c(
            "div",
            {
              staticClass: "picker-alls",
              on: {
                click: function($event) {
                  _vm.showReportType = !_vm.showReportType
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.queryParams.reportTypeName || "请选择报表类型") +
                  "\n          "
              ),
              _c("div", { staticClass: "triangle_border_down" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showReportType,
                  expression: "showReportType"
                }
              ]
            },
            [
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showReportType,
                    callback: function($$v) {
                      _vm.showReportType = $$v
                    },
                    expression: "showReportType"
                  }
                },
                [
                  _c("van-picker", {
                    attrs: {
                      "show-toolbar": "",
                      columns: _vm.reportTypeList,
                      "value-key": "name"
                    },
                    on: {
                      confirm: _vm.reportTypeChange,
                      cancel: function($event) {
                        _vm.showReportType = !_vm.showReportType
                      }
                    },
                    model: {
                      value: _vm.queryParams.reportType,
                      callback: function($$v) {
                        _vm.$set(_vm.queryParams, "reportType", $$v)
                      },
                      expression: "queryParams.reportType"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-report-chart" }, [
        _c("div", { attrs: { id: "level1-chart-container" } }),
        _vm._v(" "),
        _vm.showLevel2Chart
          ? _c("div", { attrs: { id: "level2-chart-container" } })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-report-chart" }, [
        _vm.queryParams.reportType == _vm.reportTypeMap.prodOneSortAmount &&
        _vm.tableData.prodOneSale &&
        _vm.tableData.prodOneSale.length > 0
          ? _c("table", { staticClass: "table-report" }, [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", [_vm._v("一级分类")]),
                    _vm._v(" "),
                    _vm._l(_vm.tableData.prodOneSale, function(item) {
                      return _c("th", [_vm._v(_vm._s(item.salesName || ""))])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.tableData.prodOneSale[0].list || [], function(
                  prodItem,
                  pindex
                ) {
                  return _c(
                    "tr",
                    [
                      _c("td", [_vm._v(_vm._s(prodItem.prodName))]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.prodOneSale, function(item) {
                        return _c("td", [
                          _vm._v(
                            _vm._s(
                              item.list[pindex].amount > 0
                                ? _vm
                                    .$numeral(item.list[pindex].amount || 0)
                                    .format("0,0.00")
                                : ""
                            )
                          )
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.prodTwoSortAmount &&
        _vm.tableData.prodTwoSale &&
        _vm.tableData.prodTwoSale.length > 0
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-prodTwoSortAmount" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [_vm._v("二级分类")]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.prodTwoSale, function(item) {
                        return _c("th", [_vm._v(_vm._s(item.salesName || ""))])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.tableData.prodTwoSale[0].list || [], function(
                    prodItem,
                    pindex
                  ) {
                    return _c(
                      "tr",
                      [
                        _c("td", [_vm._v(_vm._s(prodItem.prodName))]),
                        _vm._v(" "),
                        _vm._l(_vm.tableData.prodTwoSale, function(item) {
                          return _c("td", [
                            _vm._v(
                              _vm._s(
                                item.list[pindex].amount > 0
                                  ? _vm
                                      .$numeral(item.list[pindex].amount || 0)
                                      .format("0,0.00")
                                  : ""
                              )
                            )
                          ])
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.prodOneTwoSale &&
        _vm.tableData.prodOneTwoSaleCnt &&
        _vm.tableData.prodOneTwoSaleCnt.length > 0
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-oneTwoSaleCnt" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [_vm._v("产品分类")]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.prodOneTwoSaleCnt, function(item) {
                        return _c("th", [_vm._v(_vm._s(item.prodName || ""))])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(
                    _vm.tableData.prodOneTwoSaleCnt[0].prod2ndList || [],
                    function(prodItem, pindex) {
                      return _c(
                        "tr",
                        [
                          _c("td", [_vm._v(_vm._s(prodItem.prodName))]),
                          _vm._v(" "),
                          _vm._l(_vm.tableData.prodOneTwoSaleCnt, function(
                            item
                          ) {
                            return _c("td", [
                              _vm._v(
                                _vm._s(
                                  item.prod2ndList[pindex].quantity > 0
                                    ? _vm
                                        .$numeral(
                                          item.prod2ndList[pindex].quantity || 0
                                        )
                                        .format("0,0")
                                    : ""
                                )
                              )
                            ])
                          })
                        ],
                        2
                      )
                    }
                  ),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.custSexCnt
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-custGender" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("销售顾问")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("男")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("女")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("合计")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.tableData.custGender || [], function(item, index) {
                    return _c("tr", [
                      _c("td", [_vm._v(_vm._s(item.salesName))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.manCnt || ""))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.womanCnt || ""))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(item.manCnt + item.womanCnt || ""))
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.custBelongCityCnt &&
        _vm.tableData.custCity.length > 0
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-custBelongCityCnt" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [_vm._v("所属省份")]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.custCity || [], function(item) {
                        return _c("th", [_vm._v(_vm._s(item.userName))])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.tableData.custCity[0].listMap || [], function(
                    cityItem,
                    cindex
                  ) {
                    return _c(
                      "tr",
                      [
                        _c("td", [_vm._v(_vm._s(cityItem.province))]),
                        _vm._v(" "),
                        _vm._l(_vm.tableData.custCity, function(item) {
                          return _c("td", [
                            _vm._v(
                              _vm._s(
                                item.listMap[cindex].countNumber > 0
                                  ? _vm
                                      .$numeral(
                                        item.listMap[cindex].countNumber
                                      )
                                      .format("0,0")
                                  : ""
                              )
                            )
                          ])
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.custPhotography &&
        _vm.tableData.photoTheme.length > 0
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-custPhotography" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [_vm._v("摄影主题")]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.photoTheme || [], function(item) {
                        return _c("th", [_vm._v(_vm._s(item.userName))])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.tableData.photoTheme[0].listMap || [], function(
                    cityItem,
                    cindex
                  ) {
                    return _c(
                      "tr",
                      [
                        _c("td", [_vm._v(_vm._s(cityItem.shootingType))]),
                        _vm._v(" "),
                        _vm._l(_vm.tableData.photoTheme, function(item) {
                          return _c("td", [
                            _vm._v(
                              _vm._s(
                                item.listMap[cindex].countNumber > 0
                                  ? _vm
                                      .$numeral(
                                        item.listMap[cindex].countNumber
                                      )
                                      .format("0,0")
                                  : ""
                              )
                            )
                          ])
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.custAttendSortCnt &&
        _vm.tableData.custAttendSort.length > 0
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-custAttendSortCnt" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [_vm._v("销售顾问")]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.custAttendSort || [], function(
                        item
                      ) {
                        return _c("th", [_vm._v(_vm._s(item.classes))])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(
                    _vm.tableData.custAttendSort[0].listMap || [],
                    function(cityItem, cindex) {
                      return _c(
                        "tr",
                        [
                          _c("td", [_vm._v(_vm._s(cityItem.userName))]),
                          _vm._v(" "),
                          _vm._l(_vm.tableData.custAttendSort, function(item) {
                            return _c("td", [
                              _vm._v(
                                _vm._s(
                                  item.listMap[cindex].countNumber > 0
                                    ? _vm
                                        .$numeral(
                                          item.listMap[cindex].countNumber
                                        )
                                        .format("0,0")
                                    : ""
                                )
                              )
                            ])
                          })
                        ],
                        2
                      )
                    }
                  ),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.queryParams.reportType == _vm.reportTypeMap.custInterestSortCnt &&
        _vm.tableData.custInterestSort.length > 0
          ? _c(
              "table",
              {
                staticClass: "table-report",
                attrs: { id: "tb-prod-custInterestSortCnt" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [_vm._v("销售顾问")]),
                      _vm._v(" "),
                      _vm._l(_vm.tableData.custInterestSort || [], function(
                        item
                      ) {
                        return _c("th", [_vm._v(_vm._s(item.userName))])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(
                    _vm.tableData.custInterestSort[0].listMap || [],
                    function(cityItem, cindex) {
                      return _c(
                        "tr",
                        [
                          _c("td", [_vm._v(_vm._s(cityItem.hobby))]),
                          _vm._v(" "),
                          _vm._l(_vm.tableData.custInterestSort, function(
                            item
                          ) {
                            return _c("td", [
                              _vm._v(
                                _vm._s(
                                  item.listMap[cindex].countNumber > 0
                                    ? _vm
                                        .$numeral(
                                          item.listMap[cindex].countNumber
                                        )
                                        .format("0,0")
                                    : ""
                                )
                              )
                            ])
                          })
                        ],
                        2
                      )
                    }
                  ),
                  0
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11437670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11437670","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/report4SalesAnalysis.vue
// module id = null
// module chunks = 